import { render, staticRenderFns } from "./ChessModeForm.vue?vue&type=template&id=1ec97f48&scoped=true&"
import script from "./ChessModeForm.vue?vue&type=script&lang=ts&"
export * from "./ChessModeForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec97f48",
  null
  
)

export default component.exports